module.exports = __webpack_public_path__ + "static/media/icon-caret-down.70f934dd.svg";